import { combineReducers } from "redux"
import global from "./global"
import graffiti from "./graffiti"
import navbar from "./navbar"
import shop from "./shop"

export default combineReducers({ global, graffiti, navbar, shop })
